import React from 'react';
import { motion } from 'framer-motion';
import { GlowingButton } from '../ui/GlowingButton';
import { CheckCircle, Zap, Wallet, Smartphone } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-28 pb-24 overflow-hidden bg-[#050505]" data-id="element-109">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-cyan-500/20 blur-[150px] rounded-full opacity-40 pointer-events-none" data-id="element-110" />
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay pointer-events-none" data-id="element-111" />

      <div className="container mx-auto px-4 relative z-10 grid lg:grid-cols-2 gap-12 items-center" data-id="element-112">
        {/* TEXT CONTENT (LEFT) */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left relative z-20" data-id="element-113">
          {/* Badge Superior */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8 backdrop-blur-sm animate-pulse" data-id="element-114">
            <span className="w-2 h-2 rounded-full bg-green-500 shadow-[0_0_10px_#22c55e]" data-id="element-115"></span>
            <span className="text-sm font-medium text-cyan-300 tracking-wide" data-id="element-116">
              MÉTODO PROBADO EN VENEZUELA 🇻🇪
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black tracking-tight mb-6 leading-[1.1]" data-id="element-117">
            <span className="block text-white drop-shadow-lg" data-id="element-118">
              DEJA DE SUFRIR EN BOLÍVARES.
            </span>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-500 drop-shadow-[0_0_25px_rgba(6,182,212,0.5)]" data-id="element-119">
              COBRA EN DÓLARES CON IA.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed font-light" data-id="element-120">
            ¿Tu sueldo se evapora por la inflación? Aprende a usar la
            Inteligencia Artificial desde tu celular para ofrecer servicios a
            clientes internacionales.{' '}
            <span className="text-white font-bold" data-id="element-121">
              Escapa de la crisis, recupera tu tiempo y asegura tu futuro sin
              saber programar y sin computadoras costosas.
            </span>
          </p>

          <div className="flex flex-col items-center lg:items-start gap-6" data-id="element-122">
            {/* Price Block Optimizada para Venezuela */}
            <div className="flex items-center gap-6 bg-white/5 p-5 rounded-2xl border border-cyan-500/30 backdrop-blur-md shadow-[0_0_30px_rgba(6,182,212,0.15)]" data-id="element-123">
              <div className="text-left" data-id="element-124">
                <span className="block text-sm text-gray-400 line-through font-medium" data-id="element-125">
                  Precio Regular $102
                </span>
                <span className="block text-4xl font-black text-white tracking-tight" data-id="element-126">
                  $14.99
                </span>
                <span className="block text-sm font-bold text-cyan-400 mt-1 bg-cyan-500/10 px-2 py-1 rounded inline-block" data-id="element-127">
                  Aprox. Bs. 7.150
                </span>
              </div>
              <div className="h-14 w-px bg-white/10" data-id="element-128"></div>
              <div className="text-left flex flex-col justify-center" data-id="element-129">
                <span className="flex items-center gap-1 text-green-400 text-sm font-bold bg-green-500/10 px-2 py-1 rounded w-fit mb-1" data-id="element-130">
                  <CheckCircle className="w-4 h-4" data-id="element-131" /> 85% OFF
                </span>
                <span className="block text-xs text-gray-400 font-medium" data-id="element-132">
                  Oferta Lanzamiento
                </span>
                <span className="block text-xs text-purple-400 font-medium mt-1" data-id="element-133">
                  Pago Único de por vida
                </span>
              </div>
            </div>

            {/* CTA Button */}
            <a href="https://checkout.digitalsolvex.shop/cart/43743678496856:1?checkout" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto" data-id="element-134">
              <GlowingButton size="xl" className="w-full md:w-auto min-w-[280px] shadow-[0_0_50px_rgba(6,182,212,0.4)] hover:shadow-[0_0_70px_rgba(6,182,212,0.6)] transition-shadow duration-500 text-lg font-bold" data-id="element-135">
                DESCARGAR PACK AHORA
              </GlowingButton>
            </a>

            {/* TRUST INDICATORS PARA VENEZUELA (CRÍTICO) */}
            <div className="flex flex-col items-center lg:items-start gap-2 text-sm mt-2 w-full md:w-auto" data-id="element-136">
              <span className="flex items-center justify-center lg:justify-start gap-2 text-green-400 font-bold bg-green-500/10 px-4 py-3 rounded-lg border border-green-500/30 w-full shadow-inner" data-id="element-137">
                <Wallet className="w-5 h-5 animate-pulse" data-id="element-138" /> ¡Aceptamos Pago
                Móvil, Binance y Tarjetas!
              </span>
              <span className="text-gray-400 text-xs px-2 text-center lg:text-left" data-id="element-139">
                * Referencia Tasa BCV (1$ = 450 Bs). Paga fácil y rápido sin
                tarjeta internacional.
              </span>
            </div>

            {/* Trust Bar (Logos Text) */}
            <div className="mt-4 flex flex-wrap justify-center lg:justify-start gap-4 text-sm text-gray-500 items-center opacity-80" data-id="element-140">
              <span data-id="element-141">Compatible con:</span>
              <div className="flex gap-4 grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-142">
                <span className="font-bold text-white flex items-center gap-1" data-id="element-143">
                  <Zap className="w-3 h-3 text-cyan-400" data-id="element-144" /> ChatGPT
                </span>
                <span className="font-bold text-white" data-id="element-145">Claude</span>
                <span className="font-bold text-white" data-id="element-146">Gemini</span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* VISUAL CONTENT (RIGHT) */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mt-12 lg:mt-0" data-id="element-147">
          <div className="relative z-10 animate-float" data-id="element-148">
            {/* TU IMAGEN PRINCIPAL */}
            <img src="https://cdn.magicpatterns.com/uploads/6yTWKtW1aUbE4nKgriPqy7/Pack_completo.jpg" alt="Masterkit IA Bundle" className="w-full h-auto rounded-2xl shadow-2xl border border-white/10 relative z-20" data-id="element-149" />

            {/* Floating Cards Optimizadas para VZLA */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -top-6 -right-6 z-30 bg-[#0f172a] p-3 rounded-xl border border-green-500/40 shadow-lg flex items-center gap-3" data-id="element-150">
              <div className="bg-green-500/20 p-2 rounded-lg" data-id="element-151">
                <Wallet className="w-5 h-5 text-green-400" data-id="element-152" />
              </div>
              <div data-id="element-153">
                <p className="text-xs text-gray-400" data-id="element-154">Clientes Globales</p>
                <p className="text-sm font-bold text-white" data-id="element-155">Pagos en Dólares</p>
              </div>
            </motion.div>

            <motion.div animate={{
            y: [0, 10, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 1
          }} className="absolute -bottom-8 -left-4 z-30 bg-[#0f172a] p-3 rounded-xl border border-cyan-500/40 shadow-lg flex items-center gap-3" data-id="element-156">
              <div className="bg-cyan-500/20 p-2 rounded-lg" data-id="element-157">
                <Smartphone className="w-5 h-5 text-cyan-400" data-id="element-158" />
              </div>
              <div data-id="element-159">
                <p className="text-xs text-gray-400" data-id="element-160">Herramienta</p>
                <p className="text-sm font-bold text-white" data-id="element-161">100% Celular</p>
              </div>
            </motion.div>

            {/* Glow effect behind image */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-tr from-cyan-500/30 to-purple-500/30 blur-[80px] -z-10 rounded-full opacity-60" data-id="element-162" />
          </div>
        </motion.div>
      </div>
    </section>;
}